import { useLanguage } from "../context/LanguageContext";
import { Reveal, SectionHeading } from "./Reveal";
import { PhotoFrame } from "./PhotoFrame";
import { PHOTOS } from "../data/siteData";

const FACT_KEYS = ["age", "nationality", "height", "foot", "positions", "club"];

export const Profile = () => {
  const { lang, t } = useLanguage();

  return (
    <section id="perfil" className="scroll-mt-20 py-20 sm:py-28" data-testid="profile-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <Reveal>
          <SectionHeading eyebrow={t.profile.eyebrow} title={t.profile.title} testId="profile-heading" />
        </Reveal>

        <div className="grid gap-10 lg:grid-cols-[0.8fr_1.2fr] lg:gap-16">
          <Reveal delay={0.1}>
            <PhotoFrame
              src={PHOTOS.portrait.src}
              alt={PHOTOS.portrait.alt[lang]}
              label="FOTO · RETRATO"
              testId="profile-photo-frame"
              className="aspect-[3/4] w-full"
            />
          </Reveal>

          <div>
            <Reveal delay={0.15}>
              <p className="max-w-2xl text-base leading-relaxed text-zinc-300 sm:text-lg" data-testid="profile-description">
                {t.profile.description}
              </p>
            </Reveal>

            <div className="mt-10 grid grid-cols-2 gap-px border border-ink-700/60 bg-ink-700/60 sm:grid-cols-3">
              {FACT_KEYS.map((key, i) => (
                <Reveal key={key} delay={0.08 * i} className="h-full">
                  <div
                    data-testid={`profile-fact-${key}`}
                    className="flex h-full flex-col gap-2 bg-ink-900 p-5 transition-colors duration-200 hover:bg-ink-800"
                  >
                    <span className="font-mono text-[10px] font-semibold uppercase tracking-[0.2em] text-zinc-500">
                      {t.profile.facts[key]}
                    </span>
                    <span className="font-display text-lg font-semibold uppercase leading-tight text-white sm:text-xl">
                      {t.profile.values[key]}
                    </span>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
